module.exports = "/static/assets/8b7ad5c2d9787b3a9bad1458387cfff1.png";